// ✅ Use COMPAT imports everywhere
import firebase from 'firebase/compat/app';
import 'firebase/compat/app-check';
import 'firebase/compat/auth';
import 'firebase/compat/database';
import 'firebase/compat/firestore';
import 'firebase/compat/functions';
import 'firebase/compat/performance';
import 'firebase/compat/storage';

// const config = {
//   apiKey: 'AIzaSyDz8Ymk3FNGiAfC1kqvqH6b4psOYkRn7Lc',
//   authDomain: 'reactportal-5992d.firebaseapp.com',
//   databaseURL: 'https://reactportal-5992d.firebaseio.com',
//   projectId: 'reactportal-5992d',
//   storageBucket: 'reactportal-5992d.appspot.com',
//   messagingSenderId: '164563547928',
//   appId: '1:164563547928:web:7ab32332b50f6910c0906d',
// };

//dev
const config = {
  apiKey: 'AIzaSyByDJdsCK73iEyXK_2GdfOtVNT97Iw5-gI',
  authDomain: 'reactportal-225702.firebaseapp.com',
  databaseURL: 'https://reactportal-225702.firebaseio.com',
  projectId: 'reactportal-225702',
  storageBucket: 'reactportal-225702.appspot.com',
  messagingSenderId: '208764478472',
  appId: '1:208764478472:web:6c3323a3e9401502ff5dbd',
};

const app = firebase.apps.length
  ? firebase.app()
  : firebase.initializeApp(config);

/* ------------------ App Check FIRST ------------------ */
// .env:
//   REACT_APP_RECAPTCHA_V3_SITE_KEY=<v3 SITE key for prod/stage only>
//   REACT_APP_DEV_APPCHECK_DEBUG_TOKEN=<optional fixed debug token for dev>
//   REACT_APP_APPCHECK_DEBUG_TOKEN=<fallback / production debug token>
const isDev = process.env.NODE_ENV === 'development';
const siteKey = !isDev ? process.env.REACT_APP_RECAPTCHA_V3_SITE_KEY || '' : '';
const isDevProject = config.projectId === 'reactportal-225702';
// Use the dev-specific debug token for the dev project, otherwise the
// fallback/production debug token. A debug token must be registered in the
// project's App Check console to avoid 403 exchange errors.
const debugToken = isDevProject
  ? process.env.REACT_APP_DEV_APPCHECK_DEBUG_TOKEN ||
    process.env.REACT_APP_APPCHECK_DEBUG_TOKEN
  : process.env.REACT_APP_APPCHECK_DEBUG_TOKEN ||
    process.env.REACT_APP_DEV_APPCHECK_DEBUG_TOKEN;

if (!window.__APPCHECK_INIT__) {
  if (isDev) {
    if (debugToken) {
      // Debug provider (no reCAPTCHA network calls)
      // Must be set BEFORE activate()
      // eslint-disable-next-line no-restricted-globals
      self.FIREBASE_APPCHECK_DEBUG_TOKEN = debugToken;

      // For compat, pass any non-empty string; in Debug mode it won't hit Google.
      firebase.appCheck().activate('local-dev', true);
      const masked = `${debugToken.slice(0, 6)}…${debugToken.slice(-4)}`;
      console.info(
        `[AppCheck] DEV Debug provider active. appId=${config.appId}, token=${masked}`,
      );
    } else {
      console.warn(
        '[AppCheck] DEV: No APPCHECK_DEBUG_TOKEN found; App Check is inactive.',
      );
    }
  } else {
    if (!siteKey) {
      console.warn(
        '[AppCheck] PROD/STAGE: Missing REACT_APP_RECAPTCHA_V3_SITE_KEY. App Check inactive.',
      );
    } else {
      firebase.appCheck().activate(siteKey, true);
      const masked = `${siteKey.slice(0, 6)}…${siteKey.slice(-4)}`;
      console.info(
        `[AppCheck] PROD/STAGE reCAPTCHA v3 active. appId=${config.appId}, siteKey=${masked}`,
      );
    }
  }
  window.__APPCHECK_INIT__ = true;
}
/* -------------- end App Check FIRST -------------- */

// Create singletons AFTER App Check so tokens attach
const perf = firebase.performance();
const db = firebase.firestore();
const auth = firebase.auth();
const functions = firebase.functions();
const rtdb = firebase.database();
const storage = firebase.storage();

// Emulators (opt-in)
const USING_EMULATORS =
  window.location.hostname === 'localhost' &&
  process.env.REACT_APP_USE_EMULATORS === 'true';

if (!window.__FIREBASE_INIT_DONE__) {
  if (USING_EMULATORS) {
    db.useEmulator('localhost', 8080);
    auth.useEmulator('http://localhost:9099/');
    functions.useEmulator('localhost', 5001);
    rtdb.useEmulator('localhost', 9000);
  }

  // Single source of truth for Firestore settings — must run before any
  // Firestore usage and before enablePersistence().
  // merge: true avoids the compat SDK's "overriding the original host" warning.
  db.settings({
    ignoreUndefinedProperties: true,
    cacheSizeBytes: 100 * 1024 * 1024,
    merge: true,
  });

  db.enablePersistence({ synchronizeTabs: true }).catch((err) => {
    if (err?.code !== 'failed-precondition' && err?.code !== 'unimplemented') {
      console.warn('Firestore persistence error:', err);
    }
  });

  auth.setPersistence(firebase.auth.Auth.Persistence.LOCAL).catch((err) => {
    console.warn('Auth persistence error:', err);
  });

  window.__FIREBASE_INIT_DONE__ = true;
}

export default firebase;
export { app, auth, db, functions, perf, rtdb, storage };
